import { CombinedVueInstance } from 'vue/types/vue';
import { Component, Mixins } from 'vue-property-decorator';
import { ROUTE_NAME } from '@/lib/constant';
import PopupComponent from '@/components/messageBox/popup';
import router from '@/router';

// 18届 切换套餐弹窗
@Component({
    name: 'ChangePackagePopup',
    template: `<MyPopup v-model="value" :modal="true" class="change-package-popup" position="center">
        <div class="change-package-popup__content" @click="onClickDetail">
            <div><i class="icon fr" @click.stop="onClickCloseChangePackagePopup">&#xe64b;</i></div>
        </div>
    </MyPopup>`,
})
export class ChangePackagePopup extends Mixins(PopupComponent) {

    public onClickCloseChangePackagePopup() {
        this.value = false;
    }

    public onClickDetail() {
        this.onClickCloseChangePackagePopup();
        router.push({
            name: ROUTE_NAME.ACTIVITY_EQUIPMENT,
            params: {
                activityId: '24',
            },
        });
    }
}

export type ChangePackagePopupComponent = CombinedVueInstance<ChangePackagePopup, object, object, object, Record<keyof object, any>>;
